export default "__VITE_ASSET__D4pK1AtY__"